(function () {
    'use strict';

    angular
        .module('blocks.smart')
        .directive('smartMultiSelect', smartMultiSelect);

    /* @ngInject */
    function smartMultiSelect() {
        // allows us to have a select filter on smart tables.
        // Usage:
        //  <smart-select collection="vm.someCollection"></smart-select>
        // Creates:
        //  <smart-select collection="vm.someCollection">
        //  <select><select>
        //  </smart-select>
        var directive = {
            require: '^stTable',
            scope: {
                placeholder: '=',
                model: '=',
                itemLabel: '=',
                itemId: '=',
                itemParentId: '=',
                itemAdded: '=',
                itemRemoved: '=',
                collection: '='
            },
            templateUrl: 'app/blocks/smart-table-controls/templates/smart-multi-select.html',
            //required in 1.3+ with controllerAs
            bindToController: true,
            controller: controller,
            controllerAs: 'vm'
        };
        return directive;

        /* @ngInject */
        function controller() {
            /*jshint validthis:true */
            var vm = this;

            vm.onSelect = onSelect;
            vm.onRemove = onRemove;

            function onSelect($item, $model) {
                if (!!vm.itemAdded) {
                    vm.itemAdded(vm.itemParentId, $item, $model);
                }
            }

            function onRemove($item, $model) {
                if (!!vm.itemAdded) {
                    vm.itemRemoved(vm.itemParentId, $item, $model);
                }
            }
        }
    }
})();

